import { LicenseDashboardSection } from '@/pages/dashboard/components/LicenseDashboardSection'
import { TransactionDashboardSection } from '@/pages/dashboard/components/TransactionDashboardSection'

const SuperAdminDashboard = () => {
	return (
		<div className="min-w-0 w-full text-foreground">
			<header className="mb-8">
				<div className="inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/10 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-primary">
					<i className="ri-shield-star-line" aria-hidden />
					Super admin
				</div>
				<h1 className="mt-4 font-display text-3xl font-semibold tracking-tight text-foreground lg:text-[2.5rem]">
					Operations dashboard
				</h1>
				<p className="mt-2 max-w-2xl text-sm font-medium text-muted-foreground lg:text-base">
					Monitor licenses, activations, and subscription revenue. Each section has its own date filter and links to full analytics.
				</p>
			</header>

			<div className="space-y-8">
					<LicenseDashboardSection />
					<TransactionDashboardSection />
				</div>
		</div>
	)
}

export default SuperAdminDashboard
